var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitiated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "#3B579D",
    stroke: "#3B579D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98984 6.33125L6.05691 3.9849C6.01519 3.95154 5.96204 3.92882 5.90418 3.91962C5.84632 3.91042 5.78635 3.91514 5.73185 3.9332C5.67735 3.95126 5.63077 3.98184 5.59798 4.02107C5.5652 4.0603 5.54769 4.10643 5.54767 4.15362V8.84619C5.54762 8.89341 5.56508 8.93958 5.59785 8.97885C5.63062 9.01812 5.67722 9.04873 5.73176 9.0668C5.78629 9.08486 5.8463 9.08958 5.90418 9.08034C5.96206 9.0711 6.01522 9.04833 6.05691 9.01491L8.98984 6.66869C9.01757 6.64654 9.03956 6.62024 9.05457 6.59129C9.06958 6.56234 9.0773 6.53131 9.0773 6.49997C9.0773 6.46863 9.06958 6.43759 9.05457 6.40864C9.03956 6.37969 9.01757 6.35339 8.98984 6.33125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.125,
    height: 6.5,
    fill: "white",
    transform: "translate(3.25 3.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiated);
export default __webpack_public_path__ + "static/media/initiated.c41acc64e3e1389d2e94d9ea08d209c6.svg";
export { ForwardRef as ReactComponent };